import React from 'react';
import { FormattedMessage } from 'react-intl';

export const mapSavedMessage = () => ({
  text: <FormattedMessage id="coverageareamap.notifications.map-saved" />,
});

export const mapSaveFailedMessage = () => ({
  text: <FormattedMessage id="coverageareamap.notifications.map-save-failed" />,
  icon: 'cancel',
});



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/notificationMessages.jsx